const state = {
  initialized: false,
  showSplash: true,
  splashMessage: '',
  splashTotal: 0,
  splashMinDurationFinished: false,
  finalizeSplash: false,
  organisationList: [],
  organisationListLastUpdateTime: null,
  organisationListLoading: true,
  loadingOrganisationNumbers: false,
  organisationNumbers: [],
  currentNumber: null,
  currentOrganisation: {
    id: '',
    logo: '',
    name: '',
    slug: '',
    address: '',
    businesses: [],
    // TODO determine from where and how the online param will be triggered. ATM only the availabel param is being send through pusher
    user_availability: {
      available: true,
      online: true,
    },
  },
  currentOrganisationBusinessIds: [], // helper lookup - to be removed once we switch everything to ORG?
  currentOrganisationLoading: false,
  organisationMembersLoading: false,
  organisationMembers: [],
  organisationMembersLookup: {},
  organisationMembers2: {},
  organisationTeamsLoading: false,
  organisationTeams: [],
  integrationsData: [],
  numberIntegrationMap: {},
  numberIntegrationData: {},
  integrationsRegistryData: [],
  channelsDataRegistry: [],
  statistics: {},
  statisticLocalData: {},
  forceResync: 0,
  reloadOrganisationList: 0,
  updateBillingPage: 0,
  apiError: {},
  progressActions: {
    // 1234567890: {
    //   id: 1234567890,
    //   type: 'import',
    //   icon: {
    //     fileName: 'action-import.svg',
    //   },
    //   title: 'Importing contacts',
    //   subtitle: 'Preparing...',
    //   progress: 0,
    //   state: ProgressStates.PAUSED,
    //   startDate: 1679922410,
    //   stats: {},
    // },
  },
  features: {},
  totalUnreadConversations: 0,
  // This offset counts can be used if counters will still be off after the fix on Jan 29 2024
  localStatsOffsetCount: {},
  localStatsOffsetIds: {},
  localStatsOffsetMyChatCount: {},
  aiAssistants: [],
  webWidgets: [],
  paymentUpdate: {},
};

export default state;
